import { ReactNode, useMemo } from 'react';

type SSRSafeRender = {
  readonly children: ReactNode;
  /**
   * Fallback component to render if server-side rendering is detected.
   * We don't want to SSR internal pages (ie profiles) for logged in users
   * as that requires handling special cases of client-only components.
   */
  readonly fallback?: ReactNode;
  readonly skipServerRender: boolean;
};

/**
 * Renders a component only on the client-side and ensures
 * that the ssr render is the same as the initial client render.
 */
export const SSRSafeRender = ({
  children,
  fallback = null,
  skipServerRender,
}: SSRSafeRender) => {
  // Make sure the fallback prop is memoized so it doesnt trigger unnecessary re-renders
  const Fallback = useMemo(() => fallback, [fallback]);

  if (skipServerRender && typeof window === 'undefined') {
    return Fallback;
  }

  return <>{children}</>;
};
